module.exports = __webpack_public_path__ + "img/page_title_4.46687d40.png";